import { useQuery } from '@tanstack/react-query';
import {
  App,
  Card,
  DatePicker,
  Divider,
  Flex,
  Input,
  Select,
  Spin,
  Table,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import Heading from '../../components/common/Heading/Heading';
import { getStockBalance } from '../../network/stockBalanceReport';
import { queryKeys } from '../../services/react-query/queryKeys';
import {
  getItemPriceReport,
  getStockLedgerReport,
} from '../../network/stockLedgerReport';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { getSearchApi } from '../../network/itemList';
import { useParams } from 'react-router-dom';
import { getPurchaseRecieptDetails } from '../../network/purchaseReciept';
import {
  getDebitNote,
  getPurchaseInvoiceDetails,
} from '../../network/purchaseInvoice';
import { getSalesInvoiceDetails } from '../../network/PaymentEntry';
import DashboardCards from '../Dashboard/DashboardCards';
const { RangePicker } = DatePicker;
const ItemPriceReport = ({ t, invoice, reciept, note, credit }) => {
  const { idInvoice, idReciept, idNote, idCreditNote } = useParams();
  const { currentLang, companyName } = useSelector((state) => state.user);
  const [sourceData, setSourceData] = useState({
    from_date: dayjs().startOf('year').format('YYYY-MM-DD'),
    to_date: dayjs().format('YYYY-MM-DD'),
    warehouse: '',
    item_code: '',
    stock_uom: '',
    voucher_no: '',
  });
  console.log(sourceData, 'sourceData');

  const { data: stockBalanceDetails, isLoading } = useQuery({
    queryKey: [queryKeys.getItemPriceReport, currentLang],
    queryFn: () => getItemPriceReport(currentLang),
  });
  const { message } = App.useApp();
  const { data: Warehouse } = useQuery({
    queryKey: [queryKeys.getWarehouseSearch],
    queryFn: () => getSearchApi('Warehouse'),
    keepPreviousData: true,
  });
  const { data: items } = useQuery({
    queryKey: [queryKeys.getItemsSearch],
    queryFn: () => getSearchApi('Item'),
    keepPreviousData: true,
  });
  const columns = stockBalanceDetails?.message?.columns?.map((col) => ({
    title: col?.label,
    dataIndex: col?.fieldname,
    key: col?.fieldname,
    // width: col.width,
  }));
  useEffect(() => {
    if (credit && idCreditNote) {
      setSourceData({
        ...sourceData,
        from_date: dayjs().format('YYYY-MM-DD'),
        to_date: dayjs().add(1, 'month').format('YYYY-MM-DD'),
        voucher_no: idCreditNote,
      });
    }
  }, [idCreditNote, credit]);
  const dataSource = stockBalanceDetails?.message?.result?.map(
    (item, index) => ({
      key: index,
      ...item,
      date: dayjs(item.date).format('YYYY-MM-DD'),
      posting_time: dayjs(item.posting_time).format('HH:mm'),
    })
  );

  return (
    <div className="stock-balance-report">
      {/* <Heading title={t.inventory} subTitle={t.ItemPriceReport} path="/" /> */}
      <DashboardCards t={t} />
      <Card className="mt-5">
        <Flex>
          <Input.Search
            placeholder="بحث بالاسم"
            // onSearch={(value) => setSearchText(value)}
            // onChange={(value) => setSearchText(value.target.value)}
            style={{ width: 200 }}
            allowClear
            className="search-input-ant mb-5"
            // className="form-control"
            prefix={<SearchOutlined />}
          />
        </Flex>
        <Table
          className="table_custom"
          columns={columns}
          dataSource={dataSource}
          loading={isLoading}
          pagination={{ hideOnSinglePage: true }}
          rowKey="key"
          scroll={{ x: 'max-content' }}
          // summary={() => (
          //   <Table.Summary.Row>
          //     {totalRow?.map((value, index) => (
          //       <Table.Summary.Cell key={index}>{value}</Table.Summary.Cell>
          //     ))}
          //   </Table.Summary.Row>
          // )}
        />
      </Card>
    </div>
  );
};

export default ItemPriceReport;
